export const QUESTION_TYPE_OPTIONS = [
  { value: "single_line", label: "Tekstveld één regel" },
  { value: "multi_line", label: "Tekstveld meerdere regels" },
  { value: "radio", label: "Multiple choice" },
  { value: "star_rating", label: "Sterrenbeoordeling" },
] as const;

/** `CHECKBOX` is "Multiple choice" with "Meerdere antwoorden mogelijk" ticked. */
export const QUESTION_TYPES = {
  SINGLE_LINE: "single_line",
  MULTI_LINE: "multi_line",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  STAR_RATING: "star_rating",
} as const;

export const QUESTION_TYPES_WITH_OPTIONS: readonly string[] = [
  QUESTION_TYPES.RADIO,
  QUESTION_TYPES.CHECKBOX,
];

export const questionTypeHasOptions = (type: string): boolean =>
  QUESTION_TYPES_WITH_OPTIONS.includes(type);

export const QUESTION_TYPE_LABELS: Record<string, string> = {
  single_line: "Tekstveld één regel",
  multi_line: "Tekstveld meerdere regels",
  radio: "Multiple choice",
  checkbox: "Multiple choice (meerdere antwoorden)",
  star_rating: "Sterrenbeoordeling",
};

export const QUESTION_TYPE_ICONS: Record<string, string> = {
  single_line: "fa-duotone fa-align-left",
  multi_line: "fa-duotone fa-align-justify",
  radio: "fa-regular fa-circle-dot",
  checkbox: "fa-regular fa-square-check",
  star_rating: "fa-regular fa-star",
};
